module.exports = __webpack_public_path__ + "media/images/icon_interact_category-7cbdf0bcc09bac5e81702c2f53ae0f26.png";